var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.71 3.06c3.1.16 5.08 1.13 5.23 4.23.08 1.48.08 7.94 0 9.42-.16 3.1-2.13 4.08-5.23 4.23-1.48.08-5.94.08-7.42 0-3.1-.16-5.08-1.13-5.23-4.23-.08-1.48-.08-7.94 0-9.43C3.22 4.2 5.2 3.21 8.3 3.06c1.48-.08 5.94-.08 7.42 0ZM6 7.44a1.44 1.44 0 1 1 2.89 0 1.44 1.44 0 0 1-2.89 0Zm6.7 3.68a2.6 2.6 0 0 1 2.33-1.29c2.51 0 2.97 1.64 2.97 3.78V18h-2.47v-3.89c0-.92-.01-2.1-1.29-2.1s-1.5 1.01-1.5 2.05V18h-2.46v-7.98h2.36v1.1h.06ZM6.24 18v-7.98h2.5V18h-2.5Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.256a3759d6123c00888d330d174c3043.svg";
export { ForwardRef as ReactComponent };